import React, { useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import BackIcon from "../assets/icons/thinkIcons/backIcon.png";
import UploadIcon from "../assets/icons/thinkIcons/Upload.png";

export default function MultipleTransaction() {
  const navigate = useNavigate();
  const [file, setFile] = useState(null);
  const [previewData, setPreviewData] = useState([]);
  const [fraudCounts, setFraudCounts] = useState({});
  const [graphUrl, setGraphUrl] = useState(null);
  const fileInputRef = useRef(null);

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };

  const handleCircleClick = () => {
    fileInputRef.current.click(); // Programmatically open file dialog
  };

  const handleCheckTransactions = async () => {
    if (!file) return alert("Please upload a file");

    const formData = new FormData();
    formData.append("file", file);

    const res = await fetch(
      `${process.env.REACT_APP_API_URL}/fraud/check-multiple-transactions`,
      {
        method: "POST",
        body: formData,
      }
    );

    const data = await res.json();

    if (data.error) {
      alert(data.error);
      return;
    }

    // Save only first 5 records for preview
    if (data.fraud_counts) setFraudCounts(data.fraud_counts);
    if (data.graph_path) {
      // Extract filename from path and use new proxy route
      const filename = data.graph_path.split("/").pop();
      setGraphUrl(
        `${process.env.REACT_APP_API_URL}/fraud/show-graph/${filename}`
      );
    }

    console.log()

    if (data.preview_records) {
      setPreviewData(data.preview_records.slice(0, 5));
    } else {
      // If API sends whole data as df, take first 5 manually
      if (Array.isArray(data) && data.length > 0) {
        setPreviewData(data.slice(0, 5));
      }
    }
  };

  return (
    <div className="p-4 sm:p-6 md:p-8 lg:p-10">
      {/* Back Button */}
      <div className="flex justify-end">
        <button
          onClick={() => navigate("/user/dashboard/fraud_detection")}
          className="flex items-center gap-2 border border-black px-3 py-2 rounded-full cursor-pointer"
        >
          <img src={BackIcon} alt="Back" />
          <span className="text-xs sm:text-sm md:text-base">Back</span>
        </button>
      </div>

      <h2 className="textcolor font-semibold mt-4 mb-8 text-base sm:text-lg md:text-3xl">
        | Check for Multiple Transactions
      </h2>

      {/* Upload Section */}
      <div className="border-1 border-blue-custom rounded-xl p-4 sm:p-6 md:p-8">
        <p className="text-center mb-6 text-[14px] sm:text-[15px] md:text-lg font-semibold">
          Upload a csv file here to check multiple transactions.
        </p>

        {/* Upload Box */}
        <div className="max-w-full sm:max-w-xl mx-auto border-2 border-dashed border-blue-custom bg-[#0D568E1A] rounded-xl py-6 px-4 flex flex-col items-center justify-center mb-10">
          {/* Hidden File Input */}
          <input
            type="file"
            accept=".csv"
            ref={fileInputRef}
            onChange={handleFileChange}
            className="hidden"
          />

          {/* Upload Icon Circle */}
          <div
            className="w-12 h-12 sm:w-14 sm:h-14 bg-white rounded-full flex items-center justify-center mb-2 shadow-sm cursor-pointer"
            onClick={handleCircleClick}
          >
            <img
              src={UploadIcon}
              alt="Upload"
              className="w-6 h-6 sm:w-7 sm:h-7"
            />
          </div>

          <p className="textcolor font-semibold text-base sm:text-lg">
            Upload File
          </p>
          <p className="text-center text-xs sm:text-sm textblack">
            Drag & Drop or choose file to upload
          </p>

          {/* File name preview */}
          {file && (
            <p className="mt-2 text-xs sm:text-sm text-gray-600 break-words max-w-full text-center">
              {file.name}
            </p>
          )}
        </div>

        {/* Button */}
        <div className="flex justify-center">
          <button
            onClick={handleCheckTransactions}
            className="bg-[#005B99] text-white px-4 sm:px-6 py-2 rounded-md shadow hover:bg-[#004A80] transition text-sm sm:text-base"
          >
            Check Transaction
          </button>
        </div>
      </div>

      {/* Fraud Counts */}
      {Object.keys(fraudCounts).length > 0 && (
        <div className="mt-6 flex flex-col sm:flex-row gap-4 justify-center">
          <div className="bg-green-100 px-4 py-2 rounded text-center">
            Not Fraudulent: {fraudCounts[0] || 0}
          </div>
          <div className="bg-red-100 px-4 py-2 rounded text-center">
            Fraudulent: {fraudCounts[1] || 0}
          </div>
        </div>
      )}

      {/* Preview Table */}
      {previewData.length > 0 && (
        <div className="overflow-x-auto">
          <table className="mt-6 border-collapse border border-gray-300 w-full text-xs sm:text-sm">
            <thead className="bg-gray-100">
              <tr>
                {Object.keys(previewData[0]).map((key) => (
                  <th key={key} className="border p-2 whitespace-nowrap">
                    {key}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {previewData.map((row, idx) => (
                <tr key={idx}>
                  {Object.values(row).map((val, i) => (
                    <td key={i} className="border p-2 whitespace-nowrap">
                      {val}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {/* Graph */}
      {graphUrl && (
        <div className="mt-6 flex justify-center">
          <img
            src={graphUrl}
            alt="Fraud Graph"
            className="max-w-full h-auto rounded-lg"
          />
        </div>
      )}
    </div>
  );
}

// return (
//   <div className="sm:p-4 md:p-8 lg:p-10">
//     {/* Back Button */}
//     <div className="flex justify-end">
//       <button
//         onClick={() => navigate("/user/dashboard/fraud_detection")}
//         className="flex items-center gap-2 border border-black px-3 py-2 rounded-full cursor-pointer"
//       >
//         <img src={BackIcon} alt="Back" />
//         <span className="text-xs">Back</span>
//       </button>
//     </div>

//     <h2 className="textcolor font-semibold mt-4 mb-8">
//       | Check for Multiple Transactions
//     </h2>

//     {/* Upload Section */}
//     <div className="border-1 border-blue-custom rounded-xl p-6">
//       <p className="text-center mb-6 text-[15px] font-semibold">
//         Upload a csv file here to check multiple transactions.
//       </p>

//       {/* Upload Box */}
//       <div className="max-w-xl mx-auto border-2 border-dashed border-blue-custom bg-[#0D568E1A] rounded-xl py-6 px-4 flex flex-col items-center justify-center mb-10">
//         {/* Hidden File Input */}
//         <input
//           type="file"
//           accept=".csv"
//           ref={fileInputRef}
//           onChange={handleFileChange}
//           className="hidden"
//         />

//         {/* Upload Icon Circle (Clickable) */}
//         <div
//           className="w-14 h-14 bg-white rounded-full flex items-center justify-center mb-2 shadow-sm cursor-pointer"
//           onClick={handleCircleClick}
//         >
//           <img src={UploadIcon} alt="Upload" className="w-7 h-7" />
//         </div>

//         <p className="textcolor font-semibold text-lg">Upload File</p>
//         <p className="text-center text-sm textblack">
//           Drag & Drop or choose file to upload
//         </p>

//         {/* File name preview */}
//         {file && <p className="mt-2 text-sm text-gray-600">{file.name}</p>}
//       </div>

//       {/* Button */}
//       <div className="flex justify-center">
//         <button
//           onClick={handleCheckTransactions}
//           className="bg-[#005B99] text-white px-6 py-2 rounded-md shadow hover:bg-[#004A80] transition"
//         >
//           Check Transaction
//         </button>
//       </div>
//     </div>

//     {/* Fraud Counts */}
//     {Object.keys(fraudCounts).length > 0 && (
//       <div className="mt-6 flex gap-4 justify-center">
//         <div className="bg-green-100 px-4 py-2 rounded">
//           Not Fraudulent: {fraudCounts[0] || 0}
//         </div>
//         <div className="bg-red-100 px-4 py-2 rounded">
//           Fraudulent: {fraudCounts[1] || 0}
//         </div>
//       </div>
//     )}

//     {/* Preview Table */}
//     {previewData.length > 0 && (
//       <table className="mt-6 border-collapse border border-gray-300 w-full text-sm">
//         <thead className="bg-gray-100">
//           <tr>
//             {Object.keys(previewData[0]).map((key) => (
//               <th key={key} className="border p-2">
//                 {key}
//               </th>
//             ))}
//           </tr>
//         </thead>
//         <tbody>
//           {previewData.map((row, idx) => (
//             <tr key={idx}>
//               {Object.values(row).map((val, i) => (
//                 <td key={i} className="border p-2">
//                   {val}
//                 </td>
//               ))}
//             </tr>
//           ))}
//         </tbody>
//       </table>
//     )}

//     {/* Graph */}
//     {graphUrl && (
//       <div className="mt-6 flex justify-center">
//         <img src={graphUrl} alt="Fraud Graph" className="max-w-full h-auto" />
//       </div>
//     )}
//   </div>
// );
